import { handleDeleteRequest, handleGetRequest, handlePostRequest, handlePutRequest } from '.';
import { URI } from '../../constants/URI';
import { setUser } from '../slices/authSlice';
import { setUsers, setUsersPagination } from '../slices/usersSlice';
import { store } from '../store';

export const registerUser = async (body, { isFetch = false }) => {
  const res = await handlePostRequest(URI.register, body);
  if (res?.ack && isFetch) getUsers();
  return res;
};

export const loginUser = async (body) => {
  const res = await handlePostRequest(URI.login, body);
  return res;
};

export const loggedInUser = async () => {
  const res = await handleGetRequest(URI.me);
  if (res?.ack) store.dispatch(setUser(res.user));
  return res;
};

export const getUsers = async ({
  page,
  searchText = '',
  searchEmail = '',
  role = '',
  status = '',
  loading,
} = {}) => {
  const res = await handlePostRequest(URI.users, null, {
    toast: false,
    loading,
    params: { page, searchText, searchEmail, role, status },
  });
  if (res?.ack) {
    store.dispatch(setUsers(res.users));
    store.dispatch(setUsersPagination(res?.pagination));
  }
  return res;
};

export const getUser = async ({ id }) => {
  const res = await handleGetRequest(URI.user, null, { params: { id }, toast: false });
  return res;
};

export const updateUser = async (body, isCurrentUser, { isFetch = true }) => {
  const res = await handlePutRequest(URI.user, body);
  if (res && isCurrentUser) await loggedInUser();
  else if (res && isFetch) await getUsers();
  return res;
};

export const deleteUser = async (body) => {
  const res = await handleDeleteRequest(URI.user, body);
  if (res) getUsers();
  return res;
};

export const addRestaurantUser = async (body) => {
  const res = await handlePostRequest(URI.restaurants_user, body, {
    toast: false,
  });
  return res;
};

export const forgotPassword = async (body) => {
  const res = await handlePostRequest(URI.forgot_password, body, {
    toast: false,
  });
  return res;
};

export const resetPassword = async (body) => {
  const res = await handlePostRequest(URI.reset_password, body);
  return res;
};
